export const apiPath = process.env.REACT_APP_API_PATH
export const apiURL = process.env.REACT_APP_REST_BASE
export const apiBase = apiPath + apiURL
export const env = process.env.REACT_APP_ENVIRONMENT

export const addLeadingZero = (num, size = 2) => {
  var s = num + ''
  while (s.length < size) {
    s = '0' + s
  }
  return s
}

export const lowercaseHyphen = string => {
  return string && string.toLowerCase().split(' ').join('-')
}

export const removeTrailingSlash = string => {
  return string && string.endsWith('/') ? string.substring(0, string.length - 1) : string
}

export const navReplace = (string, translation) => {
  if (translation.currentLang === 'en') {
    return string.replace('/project/', '/work/')
  } else {
    return string.replace('/project/', '/projets/')
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js